// router.js
import {
  createBrowserRouter,
} from 'react-router-dom';
import App from './App';

const router = createBrowserRouter(
  [
    {
      path: "*", // todas tus rutas están dentro de <App />
      element: <App />,
    },
  ],
  {
    // ⚠️ Activando la bandera de futuras versiones
    future: {
      v7_startTransition: true,
    },
  }
);

export default router;
